import Tooltip from './StyledToolTip';
import { withStyles } from '@material-ui/core/styles';

const styles = (theme) => ({
  refreshIcon: {
    float: 'left',
    cursor: 'pointer',
    color: theme.headerIconColor,
    '&:hover': {
      color: theme.commonAppHeaderTabColor
    }
  },
  disableRefreshIcon: {
    color: theme.disableButtonBG,
    '&:hover': {
      color: theme.disableButtonBG
    }
  },
  tooltipPopper: {
    zIndex: 2000 // Higher than the dialog z-index
  }
});

const RefreshIconButton = ({
  classes,
  isRefreshing = false,
  defaultTooltip = 'Refresh data',
  refreshingTooltip = 'Refreshing data',
  onRefresh = null,
  isDisabled = false,
}) => {
  return (
    <Tooltip
      title={isRefreshing ? refreshingTooltip : defaultTooltip}
      classes={{
        popper: classes.tooltipPopper
      }}>
      <div onClick={isDisabled ? '' : onRefresh}>
        <i
          className={`${classes.refreshIcon} ${
            isDisabled ? classes.disableRefreshIcon : ''
          } icon-refresh-1 ${isRefreshing ? 'animate-spin' : ''}`}></i>
      </div>
    </Tooltip>
  );
};

export default withStyles(styles)(RefreshIconButton);
